import { connectWithStore } from 'connectWithStore'
import {loginModule} from 'modules/login/login-module'
import { react2angular } from 'react2angular'
import { store } from 'redux/store/store'
import { Testing } from './Testing'

loginModule.component(
    'testing',
    react2angular(connectWithStore(store, Testing, (state) => ({})))
)